/**
 * Base template for configurator
 * Converted from legacy JS to TypeScript
 */

import { ConfiguratorConfig } from '../types';
import translationInstance from '../utils/translations';

export const createWorkspaceTemplate = (modelId: string): ConfiguratorConfig => {
  // Get translation function
  const t = translationInstance.t.bind(translationInstance);

  return {
    viewer: {
      modelId: modelId,
      background: {
        color: [0.91015625, 0.91015625, 0.91015625],
      },
      defaultActions: [],
    },
    configurator: {
      options: [
        {
          _id: '5e6c9e6d-09ec-4c02-9538-section',
          actions: [],
          controlType: 'section',
          name: t('virtenzo.configurator.section_wood'),
          headlineText: t('virtenzo.configurator.section_wood'),
          classes: ['virtenzo-panel-section'],
          subOptions: [
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.section_wood'),
              classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
              href: '',
            },
            {
              _id: '8004c9f8-1534-4601-808b-bae614e372f2',
              actions: [
                {
                  _id: '9a87ee91-aa42-4d8b-a61b-b3db44d4ed46',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'wood_American Walnut Natural Oil_0',
                  materialName: 'Natural Beech',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD',
                  value: 'BEECH',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD_LABEL',
                  value: 'Natural Beech',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/natural_beech_diffuse.jpg',
              name: 'Natural Beech',
              text: 'Natural Beech',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Wood',
            },
            {
              _id: '1c2fdfe9-713b-4d1f-add6-e3d0d8cdb541',
              actions: [
                {
                  _id: '63da66a7-3008-48b9-9c54-eb467ca79ad4',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'wood_American Walnut Natural Oil_0',
                  materialName: 'Beech Nero MAT',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD',
                  value: 'BEECH',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD_LABEL',
                  value: 'Beech Nero MAT',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/beech_nero_mat_diffuse.jpg',
              name: 'Beech Nero MAT',
              text: 'Beech Nero MAT',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Wood',
            },
            {
              _id: 'dcfd0cd4-40c7-4920-92bb-53e0c384e4c5',
              actions: [
                {
                  _id: '8e449b77-aa9a-493f-9d8e-05be0588ec32',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'wood_American Walnut Natural Oil_0',
                  materialName: 'Waxed Wild Oak',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD',
                  value: 'OAK',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD_LABEL',
                  value: 'Waxed Wild Oak',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/waxed_wild_oak_diffuse.jpg',
              name: 'Waxed Wild Oak',
              text: 'Waxed Wild Oak',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Wood',
            },
            {
              _id: '07f872f7-9b87-4629-9930-605733af0628',
              actions: [
                {
                  _id: '2832a7e0-2194-49cf-be79-dae7749b6eb3',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'wood_American Walnut Natural Oil_0',
                  materialName: 'American Walnut Natural Oil',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD',
                  value: 'AMERICAN_WALNUT',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD_LABEL',
                  value: 'American Walnut Natural Oil',
                },
              ],
              controlType: 'imageButton',
              imageSrc:
                'https://static.virtenzo.com/clients/estetica-home/textures/american_walnut_natural_oil_diffuse.jpg',
              name: 'American Walnut Natural Oil',
              text: 'American Walnut Natural Oil',
              classes: ['virtenzo-panel-button', 'virtenzo-fb40'],
              href: '',
              groups: 'Wood',
            },
          ],
        },
        {
          _id: '5187435b-4144-4588-940c-section',
          actions: [],
          controlType: 'section',
          name: t('virtenzo.configurator.section_upholstery'),
          classes: ['virtenzo-panel-section'],
          subOptions: [
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.section_upholstery'),
              classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
              href: '',
            },
            
            {
              _id: '1435b9b6-12a0-468f-b4e0-30e41e09f88c',
              actions: [
                {
                  _id: '468cff77-52f5-4faf-8d4b-20f3c329639e',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'fabric_Bel Sand_0',
                  materialName: 'Leather black',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY',
                  value: 'LEATHER',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY_LABEL',
                  value: 'Leather Black',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_black.jpg',
              name: 'Leather Black',
              text: 'Leather Black',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Upholstery',
            },
            {
              _id: '1b06c328-be87-42df-bbf9-1449a51874ba',
              actions: [
                {
                  _id: 'bcd8561f-fa4b-4756-94c1-b4e3d3795e69',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'fabric_Bel Sand_0',
                  materialName: 'Dig 6009',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY',
                  value: 'CATEGORY_A',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY_LABEL',
                  value: 'Dig 6009',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/dig_6009.jpg',
              name: 'Dig 6009',
              text: 'Dig 6009',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Upholstery',
            },
            //GRUPA B
            {
              _id: '229f5507-b264-4b86-af5c-3d9d4d246f4e',
              actions: [
                {
                  _id: '850ed020-eee8-4a35-9c7f-206b60dbb627',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'fabric_Bel Sand_0',
                  materialName: 'Haga 900',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY',
                  value: 'CATEGORY_B',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY_LABEL',
                  value: 'Haga 900',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/haga_900.jpg',
              name: 'Haga 900',
              text: 'Haga 900',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Upholstery',
            },
            //GRUPA C

            {
              _id: 'a82f73c5-9ba1-4ded-bea2-93c3f88d2d2c',
              actions: [
                {
                  _id: 'f91ffd68-59ce-4d5d-b56b-45269008c9c0',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'fabric_Bel Sand_0',
                  materialName: 'Boh 800',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY',
                  value: 'CATEGORY_C',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY_LABEL',
                  value: 'Boh 800',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/boh_800.jpg',
              name: 'Boh 800',
              text: 'Boh 800',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Upholstery',
            },
            {
              _id: '03cfe2d8-ec98-4de9-b328-be6da6cfa93d',
              actions: [
                {
                  _id: '24419bca-2f13-44b9-a447-6a574a9610e3',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'fabric_Bel Sand_0',
                  materialName: 'Mag 7026',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY',
                  value: 'CATEGORY_C',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY_LABEL',
                  value: 'Mag 7026',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/mag_7026.jpg',
              name: 'Mag 7026',
              text: 'Mag 7026',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Upholstery',
            },
            {
              _id: '7476a7a2-67c1-4de3-8687-62b69c15849f',
              actions: [
                {
                  _id: '8e56a942-bf71-4dae-88c7-4375b88742b4',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'fabric_Bel Sand_0',
                  materialName: 'Mag 5001',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY',
                  value: 'CATEGORY_C',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'UPHOLSTERY_LABEL',
                  value: 'Mag 5001',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/mag_5001.jpg',
              name: 'Mag 5001',
              text: 'Mag 5001',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Upholstery',
            },
          ],
        },
      ],
        queryConfig: true,
          selector: 'virtenzo-panel',
        },
  }
}